import React, { useContext, useEffect, useMemo } from "react";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/css/froala_style.min.css";
import { froalaEditor } from "../Uitls/CommonFroalaConfig";
import "../styles/components/CommonFroalEditorComponent.scss";
import ValueContext from "../ContextAPi/appContext";
import { getResolvedCustomFonts } from "../services/customFontsApi";


const CommonFroalEditorComponent = (props) => {  
  const appData = useContext(ValueContext);

  const savedCustomFontList = useMemo(
    () =>
      getResolvedCustomFonts(
        appData?.savedCustomFontList ?? [],
      ),
    [appData?.savedCustomFontList],
  );

  const customFontConfigSignature = useMemo(
    () =>
      savedCustomFontList
        .map((row) => row.id)
        .sort()
        .join("|"),
    [savedCustomFontList],
  );

  const froalaConfig = useMemo(
    () =>
      froalaEditor.config(
        {
          placeHolder: props.placeHolder,
          shouldHaveToolbar: true,
          shouldUpdateImmediatly: props.shouldUpdateImmediatly || false,
          contentEditable:
            props.editable && props.editable === "off" ? false : true,
          showToolBar: props.showToolBar,
          savedCustomFontList,
        },
        (onclick = (event) => {
          if (props.onSupClick) {
            props.onSupClick(event);
          }
        })
      ),
    [
      props.placeHolder,
      props.shouldUpdateImmediatly,
      props.editable,
      props.showToolBar,
      savedCustomFontList,
    ]
  );

  const newEditor = (defaultText) => {
    const editorHtml = /<(p|div|h[1-6]|ul|ol|blockquote|pre)(\s|>)/i.test(
      defaultText || "",
    )
      ? defaultText
      : `<p>${defaultText || ""}</p>`;

    return (
      <FroalaEditor
        key={customFontConfigSignature || "default-fonts"}
        ref={props.forwardedRef}
        className="common-editor"
        tag="textarea"
        config={froalaConfig}
        model={editorHtml}
        onModelChange={props.handleModelChange}
      />
    );
  };

  return (
    <div
      className={`${props.className || "froalaContent"}`}
      style={{ paddingRight: props.scrollBarStyleWidth }}
    >
      {props && props.title && (
        <p className="mb-0 box-heading">{props.title}</p>
      )}

      {newEditor(props && props.defaultText ? props.defaultText : "")}
    </div>
  );
};

export default CommonFroalEditorComponent;
